import React from "react"

var bgimg1 = require("./../../images/background/bg-5.png")
var bgimg2 = require("./../../images/background/bg-2.jpg")
var bgimg3 = require("./../../images/background/cross-line2.png")

class WhatWeDo6 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full  mobile-page-padding bg-white  p-t80 p-b30 bg-repeat overflow-hide"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container right-half-bg-image-outer">
            <div
              className="right-half-bg-image bg-parallax bg-fixed bg-top-right"
              data-stellar-background-ratio={0}
              style={{ backgroundImage: "url(" + bgimg2 + ")" }}
            />
            {/* TITLE START */}
            {/* <div className="section-head">
              <div className="sx-separator-outer separator-left">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{
                    width: "100%",
                    backgroundImage: "url(" + bgimg3 + ")",
                  }}
                >
                  <h3 className="sep-line-one">What We do</h3>
                </div>
              </div>
            </div> */}
            {/* TITLE END */}
            <div className="section-content">
              <div className="row number-block-one-outer justify-content-center">
                <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                  <div className="number-block-one animate-in-to-top">
                    <a href={`/services-detail#0`}>
                      <img
                        src={require("./../../images/services/service-projects/1.jpg")}
                        alt=""
                      />
                      <div className="figcaption bg-white text-center p-a20">
                        <h4 className="m-a0">Plans and Projects</h4>
                      </div>
                      <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                        <span>01</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                  <div className="number-block-one animate-in-to-top">
                    <a href={`/services-detail#1`}>
                      <img
                        src={require("./../../images/services/service-projects/2.jpg")}
                        alt=""
                      />
                      <div className="figcaption bg-white text-center p-a20">
                        <h4 className="m-a0">Interior Design</h4>
                      </div>
                      <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                        <span>02</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                  <div className="number-block-one animate-in-to-top">
                    <a href={`/services-detail#2`}>
                      <img
                        src={require("./../../images/services/service-projects/3.jpg")}
                        alt=""
                      />
                      <div className="figcaption bg-white text-center p-a20">
                        <h4 className="m-a0">Exterior Design</h4>
                      </div>
                      <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                        <span>03</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="section-content">
                <div className="row number-block-one-outer justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                    <div className="number-block-one animate-in-to-top">
                      <a href={`/services-detail#3`}>
                        <img
                          src={require("./../../images/services/service-projects/4.jpg")}
                          alt=""
                        />
                        <div className="figcaption bg-white text-center p-a20">
                          <h4 className="m-a0">Architecture</h4>
                        </div>
                        <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                          <span>04</span>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                    <div className="number-block-one animate-in-to-top">
                      <a href={`/services-detail#4`}>
                        <img
                          src={require("./../../images/services/service-projects/5.jpg")}
                          alt=""
                        />
                        <div className="figcaption bg-white text-center p-a20">
                          <h4 className="m-a0">Furniture Design</h4>
                        </div>
                        <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                          <span>05</span>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                    <div className="number-block-one animate-in-to-top">
                      <a href={`/services-detail#5`}>
                        <img
                          src={require("./../../images/services/service-projects/6.jpg")}
                          alt=""
                        />
                        <div className="figcaption bg-white text-center p-a20">
                          <h4 className="m-a0">Decoration</h4>
                        </div>
                        <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                          <span>06</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-content">
                <div className="row number-block-one-outer justify-content-center">
                  <div className="col-lg-8 col-md-8 col-sm-6 m-b30">
                    <div className="number-block-one animate-in-to-top">
                      <a href={`/services-detail#6`}>
                        <img
                          src={require("./../../images/services/service-projects/BIM1.png")}
                          alt=""
                        />
                        <div className="figcaption bg-white text-center p-a20">
                          <h4 className="m-a0">BIM Services</h4>
                        </div>
                        <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                          <span>07</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default WhatWeDo6
